<script>
  // @ts-check
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import Bullet from "../components/Bullet.svelte";
  import Bullets from "../components/Bullets.svelte";
  import CTAs from "../components/CTAs.svelte";
  import H1 from "../components/H1.svelte";
  import P from "../components/P.svelte";
  import LicenseChip from "../components/LicenseChip.svelte";
  import Slide from "../components/Slide.svelte";

  import { getIconProps, style } from "../utils";
  const license = "conversations";
  const iconProps = getIconProps(license);
</script>

<Slide>
  <LicenseChip {style} {license}></LicenseChip>
  <H1>Turn up the heat on your cold calling</H1>
  <P>
    Calling, texting, WhatsApp – Conversations brings it all together in one
    place. Recruiters connect faster and save time on admin, and managers see
    exactly what’s driving results. No more switching tabs or chasing data. Just
    better conversations, logged and tracked where they belong.
  </P>
  <Bullets>
    <Bullet>
      <IconScale class="fa-merge" {...iconProps} />Call everywhere, from
      anywhere
    </Bullet>
    <Bullet>
      <IconScale class="fa-users-gear" {...iconProps} />Log calls back to your
      CRM
    </Bullet>
    <Bullet>
      <IconScale class="fa-square-list" {...iconProps} />Get call transcriptions
      and AI summaries
    </Bullet>
  </Bullets>
  <CTAs tourLink="https://sourcewhale.navattic.com/mnu04rq" />
</Slide>
